import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=7827e8da&scoped=true"
import script from "./SelectCourse.vue?vue&type=script&lang=js"
export * from "./SelectCourse.vue?vue&type=script&lang=js"
import style0 from "./SelectCourse.vue?vue&type=style&index=0&id=7827e8da&prod&lang=scss&scoped=true"
import style1 from "./SelectCourse.vue?vue&type=style&index=1&id=7827e8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827e8da",
  null
  
)

export default component.exports